import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-treatment',
  imports: [],
  templateUrl: './edit-treatment.component.html',
  styleUrl: './edit-treatment.component.scss',
})
export class EditTreatmentComponent {

}
